import {
  saGlobalReleaseConstants,
  addSaGlobalReleaseConstants,
  editSaGlobalReleaseConstants,
} from "../_redux-constants";
import { saGlobalReleaseService } from "../../_services";

function getSaGlobalRelease() {
  function getSaGlobalReleaseLoad() {
    return { type: saGlobalReleaseConstants.SA_GLOBAL_RELEASE_LOADING };
  }
  function getSaGlobalReleaseSuccess(data) {
    return {
      type: saGlobalReleaseConstants.SA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function getSaGlobalReleaseFailure(error) {
    return {
      type: saGlobalReleaseConstants.SA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getSaGlobalReleaseLoad());
    return saGlobalReleaseService.getSaGlobalRelease().then(
      (data) => {
        dispatch(getSaGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(getSaGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addSaGlobalRelease(formData) {
  function addSaGlobalReleaseLoad() {
    return {
      type: addSaGlobalReleaseConstants.ADD_SA_GLOBAL_RELEASE_LOADING,
    };
  }
  function addSaGlobalReleaseSuccess(data) {
    return {
      type: addSaGlobalReleaseConstants.ADD_SA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function addSaGlobalReleaseFailure(error) {
    return {
      type: addSaGlobalReleaseConstants.ADD_SA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addSaGlobalReleaseLoad());
    return saGlobalReleaseService.addSaGlobalRelease(formData).then(
      (data) => {
        dispatch(addSaGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addSaGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editSaGlobalRelease(formData) {
  function editSaGlobalReleaseLoad() {
    return {
      type: editSaGlobalReleaseConstants.EDIT_SA_GLOBAL_RELEASE_LOADING,
    };
  }
  function editSaGlobalReleaseSuccess(data) {
    return {
      type: editSaGlobalReleaseConstants.EDIT_SA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editSaGlobalReleaseFailure(error) {
    return {
      type: editSaGlobalReleaseConstants.EDIT_SA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editSaGlobalReleaseLoad());
    return saGlobalReleaseService.editSaGlobalRelease(formData).then(
      (data) => {
        dispatch(editSaGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editSaGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const saGlobalReleaseActions = {
  getSaGlobalRelease,
  addSaGlobalRelease,
  editSaGlobalRelease,
};
